/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

//FullCalendar
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "./custom-calendar.css";
import esLocale from "@fullcalendar/core/locales/es";

import { useMemo, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Grid, Icon } from "@mui/material";

const CalendarioCitas = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const citas = useMemo(() => {
    return state.citas.map((cita) => ({
      title: `${cita.nombreCandidato} ${cita.aPaternoCandidato} ${cita.aMaternoCandidato}`,
      start:
        cita.fechaCita.split("T")[0] +
        `T${String(cita.horaCita).padStart(2, "0")}:${String(cita.minutoCita).padStart(2, "0")}:00`,
      end:
        cita.fechaCita.split("T")[0] +
        `T${String(cita.horaCita).padStart(2, "0")}:${String(cita.minutoCita).padStart(2, "0")}:00`,
      ...cita,
    }));
  }, [state]);

  //   const handleDateClick = (arg) => {
  //     const nuevaCita = {
  //       id: String(citas.length + 1),
  //       title: "Nueva cita",
  //       start: arg.date,
  //       end: new Date(new Date(arg.date).getTime() + 60 * 60 * 1000), // +1 hora
  //     };
  //     setCitas([...citas, nuevaCita]);
  //   };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={1} pb={3}>
          <Grid item xs={12} md={12} lg={12}>
            <MDBox mb={1.5} py={1} px={2} display="flex" justifyContent="space-between">
              <Button
                variant="contained"
                startIcon={<Icon>arrow_back_ios_new</Icon>}
                color="primary"
                size="small"
                style={{ textTransform: "inherit" }}
                onClick={() => navigate(state?.ruta)}
              >
                Regresar
              </Button>
            </MDBox>
          </Grid>

          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth" // o "dayGridMonth", "timeGridDay"
            events={citas}
            //dateClick={handleDateClick}
            editable={true}
            selectable={true}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            locales={[esLocale]}
            locale="es"
          />
        </MDBox>
        <Footer />
      </DashboardLayout>
    </>
  );
};

export default CalendarioCitas;
